import { Components } from '@ionic/core';
import React, { ReactElement, ReactNode } from 'react';
import { useTranslation } from 'react-i18next';
import { LoadingButton } from './loading-button';
import { WithConfirmation } from './with-confirmation';

interface DeleteButtonProps {
  header?: string;
  destructivePrompt?: string;
  onDelete?: () => void;
  children?: ReactNode;
  buttonProps?:
    | (Partial<Components.IonButton> &
        Partial<React.HTMLAttributes<HTMLIonButtonElement>> &
        Partial<React.DOMAttributes<HTMLIonButtonElement>>)
    | undefined;
}

const DeleteButton = (props: DeleteButtonProps): ReactElement => {
  const { children, onDelete, header, destructivePrompt, buttonProps } = props;
  const { i18n } = useTranslation();

  return (
    <WithConfirmation
      header={header}
      destructivePrompt={destructivePrompt}
      disabled={buttonProps?.disabled ?? false}
    >
      {({ onConfirmed }) => (
        <LoadingButton
          loading={false}
          buttonProps={{
            type: 'submit',
            color: 'danger',
            disabled: false,
            fill: 'outline',
            onClick: () => {
              onConfirmed({ onConfirmation: onDelete });
            },
            ...buttonProps,
          }}
        >
          {children ?? i18n.t('common:delete')}
        </LoadingButton>
      )}
    </WithConfirmation>
  );
};

export { DeleteButton };
